import { queryKeys } from '@/lib/query-keys';
import { apiClient } from '@borradh-workspace/api-client';
import {
  type LapsedAdsNoticeResponse,
  lapsedAdsNoticeResponseSchema,
} from '@borradh-workspace/contracts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getLapsedAdsQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.billing.lapsedAds(),
    queryFn: () =>
      apiClient.get<LapsedAdsNoticeResponse>('billing/lapsed-ads', {
        schema: lapsedAdsNoticeResponseSchema,
      }),
    // Written once a day by the sweep; no need to poll.
    staleTime: 10 * 60 * 1000,
  });

/**
 * Borradh-launched campaigns still spending after the subscription ended.
 * Only asked for when the subscription has ended, so a paying clinic never
 * makes the request.
 */
export const useGetLapsedAds = ({ enabled }: { enabled: boolean }) => {
  const query = useQuery({ ...getLapsedAdsQueryOptions(), enabled });
  return {
    notice: query.data?.notice ?? null,
    isLoading: query.isLoading,
  };
};
